import { Router } from "./Router.js";
import { UrlUtils } from "@dooboostore/core";
class PathRouter extends Router {
  constructor(config) {
    super(config);
  }
  getSearchParams(data) {
    if (!this.config.window.document?.location?.href) {
      return new URLSearchParams();
    }
    const searchParams = new URL(this.config.window.document.location?.href).searchParams;
    return UrlUtils.manipulateSearchParams(searchParams, data);
  }
  push(path, state) {
    return super.pushState(state?.data, state?.title, this.toUrl(path), state?.config);
  }
  replace(path, state) {
    return super.replaceState(state?.data, state?.title, this.toUrl(path), state?.config);
  }
  pushDeleteSearchParam(name, state) {
    const s = this.getSearchParams({ delete: Array.isArray(name) ? name : [name] });
    this.push({ searchParams: s }, state);
  }
  pushDeleteHashSearchParam(name, state) {
    const s = this.getHashSearchParams({ delete: Array.isArray(name) ? name : [name] });
    const size = Array.from(s.entries()).length;
    const href = `${this.config.window.location?.pathname ?? "/"}${this.config.window.location?.search}${size > 0 ? "#" + s.toString() : ""}`;
    super.pushState(state?.data, state?.title, href, state?.config);
  }
  pushAddSearchParam(params, state) {
    const s = this.getSearchParams({ append: params });
    this.push({ searchParams: s }, state);
  }
  pushUpsertSearchParam(params, state) {
    const s = this.getSearchParams();
    UrlUtils.upsertSearchParam(s, params);
    this.push({ searchParams: s }, state);
  }
  replaceDeleteSearchParam(name, state) {
    const s = this.getSearchParams({ delete: Array.isArray(name) ? name : [name] });
    this.replace({ searchParams: s }, state);
  }
  replaceDeleteHashSearchParam(name, state) {
    const s = this.getHashSearchParams({ delete: Array.isArray(name) ? name : [name] });
    const size = Array.from(s.entries()).length;
    const href = `${this.config.window.location?.pathname ?? "/"}${this.config.window.location?.search}${size > 0 ? "#" + s.toString() : ""}`;
    super.replaceState(state?.data, state?.title, href, state?.config);
  }
  replaceAddSearchParam(params, state) {
    const s = this.getSearchParams({ append: params });
    this.replace({ searchParams: s }, state);
  }
  replaceUpsertSearchParam(params, state) {
    const s = this.getSearchParams();
    UrlUtils.upsertSearchParam(s, params);
    this.replace({ searchParams: s }, state);
  }
  getUrl() {
    if (!this.config.window.document?.location?.href) {
      return "/";
    }
    const url = new URL(this.config.window.document.location?.href);
    return url.pathname + url.search;
  }
  getHref() {
    return this.config.window.location?.href ?? "/";
  }
  getPathName() {
    return this.config.window.location?.pathname ?? "/";
  }
  getSearch() {
    return this.config.window.location?.search ?? "";
  }
  getHashSearchParams(data) {
    const searchParams = new URLSearchParams(this.config.window.location?.hash.slice(1) ?? "");
    return UrlUtils.manipulateSearchParams(searchParams, data);
  }
}
export {
  PathRouter
};
//# sourceMappingURL=PathRouter.js.map
